import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="48"
      height="48"
      viewBox="0 0 129 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9152 128C13.5309 128 16.1465 128 18.761 128C48.9217 128 79.0811 128 109.241 128C111.857 128 114.472 128 117.087 128C118.592 128 120.097 128 121.601 128C122.105 128.001 122.593 127.944 123.083 127.827C123.32 127.77 123.55 127.701 123.778 127.618C124.699 127.284 125.451 126.805 126.141 126.11C126.238 126.013 126.332 125.912 126.422 125.809C126.85 125.318 127.185 124.793 127.45 124.198C127.458 124.182 127.464 124.165 127.472 124.148C127.604 123.843 127.711 123.533 127.795 123.212C127.797 123.203 127.799 123.195 127.801 123.186C127.936 122.662 128.001 122.141 128.001 121.6C128.001 117.334 128.001 113.067 128.001 108.8C128.001 74.6666 128.001 40.5334 128.001 6.40023C128.001 2.86567 125.136 0.000549316 121.601 0.000549316C120.097 0.000549316 118.592 0.000549316 117.087 0.000549316C115.872 0.000549316 114.656 0.000549316 113.442 0.000549316C113.407 0.000549316 113.374 0.000549316 113.34 0.000549316C113.29 0.000549316 113.24 0.000549316 113.191 0.000549316C111.874 0.000549316 110.557 0.000549316 109.241 0.000549316C79.0806 0.000549316 48.9211 0.000549316 18.7605 0.000549316C17.4442 0.000549316 16.1273 0.000549316 14.8105 0.000549316C14.7608 0.000549316 14.7112 0.000549316 14.6615 0.000549316C14.6271 0.000549316 14.5937 0.000549316 14.5599 0.000549316C13.3446 0.000549316 12.1294 0.000549316 10.9141 0.000549316C9.40931 0.000549316 7.9045 0.000549316 6.40025 0.000549316C2.86512 0.000549316 0 2.86623 0 6.40023C0 40.534 0 74.6672 0 108.8C0 113.067 0 117.334 0 121.6C0 125.135 2.86512 128 6.40025 128C7.90563 128 9.41043 128 10.9152 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.667 0.0012207 108.8C0.0012207 113.066 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86636 127.999 6.40149 127.999C7.9063 127.999 9.4111 127.999 10.9159 127.999C13.531 127.999 16.1466 127.999 18.7611 127.999C48.9218 127.999 79.0812 127.999 109.241 127.999C111.857 127.999 114.473 127.999 117.087 127.999C118.592 127.999 120.097 127.999 121.602 127.999C122.106 128 122.593 127.943 123.083 127.826C123.32 127.77 123.551 127.7 123.779 127.617C124.699 127.284 125.452 126.804 126.141 126.11C126.238 126.012 126.332 125.912 126.422 125.808C126.851 125.318 127.186 124.793 127.45 124.198C127.458 124.181 127.464 124.164 127.472 124.147C127.604 123.842 127.711 123.532 127.795 123.211C127.797 123.203 127.799 123.194 127.801 123.186C127.936 122.661 128.001 122.14 128.001 121.6C128.001 117.333 128.001 113.066 128.001 108.8C128.001 108.667 128.001 108.533 128.001 108.4H0.0012207Z"
        fill="url(#paint0_linear_6150_23183)"
      />
      <path
        opacity="0.2"
        d="M19.6009 0C19.3209 0 19.0409 0 18.761 0C17.4447 0 16.1279 0 14.8116 0C14.7619 0 14.7117 0 14.662 0C14.6281 0 14.5942 0 14.5604 0C13.3451 0 12.1299 0 10.9152 0C9.41037 0 7.90557 0 6.40075 0C2.86563 0 0.000488281 2.8657 0.000488281 6.3997C0.000488281 40.5334 0.000488281 74.6666 0.000488281 108.8C0.000488281 113.066 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86563 127.999 6.40075 127.999C7.90557 127.999 9.41037 127.999 10.9152 127.999C13.5303 127.999 16.1459 127.999 18.7604 127.999C19.0404 127.999 19.3204 127.999 19.6003 127.999V0H19.6009Z"
        fill="url(#paint1_linear_6150_23183)"
      />
      <path
        opacity="0.2"
        d="M108.402 0C108.682 0 108.961 0 109.241 0C110.558 0 111.875 0 113.191 0C113.241 0 113.291 0 113.34 0C113.375 0 113.408 0 113.442 0C114.658 0 115.873 0 117.088 0C118.592 0 120.097 0 121.602 0C125.137 0 128.002 2.8657 128.002 6.3997C128.002 40.5334 128.002 74.6666 128.002 108.8C128.002 113.066 128.002 117.333 128.002 121.6C128.002 125.134 125.137 127.999 121.602 127.999C120.097 127.999 118.592 127.999 117.088 127.999C114.472 127.999 111.857 127.999 109.242 127.999C108.962 127.999 108.682 127.999 108.402 127.999V0H108.402Z"
        fill="url(#paint2_linear_6150_23183)"
      />
      <path
        d="M19.8568 19.5999C19.6761 19.5999 19.6011 19.675 19.6011 19.8562C19.6011 49.2858 19.6011 78.7149 19.6011 108.145C19.6011 108.326 19.6761 108.401 19.8568 108.401C49.2864 108.401 78.7155 108.401 108.145 108.401C108.326 108.401 108.401 108.326 108.401 108.145C108.401 78.7149 108.401 49.2858 108.401 19.8562C108.401 19.675 108.326 19.5999 108.145 19.5999C78.7161 19.5999 49.2864 19.5999 19.8568 19.5999Z"
        fill="#575756"
      />
      <path
        d="M108.002 107.744C108.002 107.926 107.927 108.001 107.745 108.001C78.5827 108.001 49.4201 108.001 20.2574 108.001C20.0768 108.001 20.0017 107.926 20.0017 107.744C20.0017 78.5817 20.0017 49.419 20.0017 20.2558C20.0017 20.0751 20.0768 20.0001 20.2574 20.0001C49.4201 20.0001 78.5827 20.0001 107.745 20.0001C107.927 20.0001 108.002 20.0751 108.002 20.2558C108.002 49.419 108.002 78.5817 108.002 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M94.9392 98.2915C93.4807 98.2915 92.0222 98.2915 90.5631 98.2915C90.654 97.4274 90.7443 96.5632 90.8351 95.6996C91.031 93.8375 93.7387 93.6693 94.1055 95.5116C94.1896 95.9231 94.7253 96.0388 94.968 95.6951C95.0431 95.589 95.0685 95.4896 95.0527 95.3609C95.0211 95.0985 94.9274 94.8699 94.8088 94.639C94.4188 93.8798 93.9142 93.5152 93.0901 93.3278C91.5085 92.9682 90.0506 93.9746 89.8795 95.5991C89.7706 96.64 89.6605 97.6808 89.5516 98.7211C89.5132 99.088 89.6594 99.2511 90.0291 99.2511C90.5337 99.2511 91.0378 99.2511 91.5418 99.2511C91.5892 100.505 93.3791 100.505 93.426 99.2511C93.9306 99.2511 94.4346 99.2511 94.9387 99.2511C95.2785 99.2511 95.419 99.1105 95.419 98.7707C95.419 98.431 95.279 98.2915 94.9392 98.2915Z"
        fill="#575756"
      />
      <path
        d="M96.7516 89.3931C96.4677 89.2074 96.273 89.2481 96.0873 89.5325C95.9016 89.8165 95.9428 90.0112 96.2267 90.1969C97.8986 91.2885 98.7368 92.5608 99.1268 94.5115C99.1934 94.844 99.3588 94.9546 99.6918 94.888C100.025 94.8208 100.135 94.6555 100.068 94.323C99.6625 92.2916 98.4924 90.5282 96.7516 89.3931Z"
        fill="#575756"
      />
      <path
        d="M84.9013 94.3224C84.8347 94.6548 84.9453 94.8208 85.2778 94.8874C85.6108 94.954 85.7762 94.8439 85.8428 94.5109C86.2323 92.5602 87.071 91.2874 88.7429 90.1963C89.0274 90.0106 89.068 89.8158 88.8823 89.5319C88.6966 89.2474 88.5025 89.2068 88.218 89.3925C86.4772 90.5282 85.3077 92.2909 84.9013 94.3224Z"
        fill="#575756"
      />
      <path
        d="M87.4457 94.6661C87.3689 94.9969 87.4773 95.1628 87.8058 95.2418C88.1377 95.3209 88.3053 95.2131 88.3815 94.8823C88.6553 93.7015 89.1825 92.9316 90.2211 92.2909C90.5095 92.112 90.5541 91.9184 90.3757 91.63C90.1974 91.3404 90.0038 91.2952 89.7153 91.4753C88.434 92.2633 87.7821 93.2099 87.4457 94.6661Z"
        fill="#575756"
      />
      <path
        d="M95.2561 91.4754C94.9671 91.2959 94.7741 91.3416 94.5946 91.6295C94.4162 91.9179 94.4614 92.1115 94.7492 92.291C95.7884 92.9311 96.3167 93.6987 96.5888 94.8818C96.665 95.2126 96.8337 95.317 97.1645 95.2425C97.4958 95.1669 97.6003 94.9975 97.5246 94.6668C97.1893 93.2082 96.5323 92.2656 95.2561 91.4754Z"
        fill="#575756"
      />
      <path
        d="M46.5482 62.2737C44.221 62.2737 44.1832 65.7129 46.5098 65.7648C48.8353 65.8156 48.8754 62.2737 46.5482 62.2737Z"
        fill="#3C3C3B"
      />
      <path
        d="M64.0009 79.7095C61.6742 79.7095 61.6358 83.1481 63.9625 83.2C66.2891 83.2519 66.3281 79.7095 64.0009 79.7095Z"
        fill="#3C3C3B"
      />
      <path
        d="M59.5654 57.0373C59.5654 54.7101 59.5654 52.3829 59.5654 50.0557C59.5654 49.0916 58.7836 48.3104 57.8196 48.3104C56.8555 48.3104 56.0737 49.0916 56.0737 50.0557C56.0737 52.3829 56.0737 54.7101 56.0737 57.0373C56.0737 58.0014 56.8555 58.7826 57.8196 58.7826C58.7836 58.7826 59.5654 58.0014 59.5654 57.0373Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.1098 74.4731C78.1098 72.1458 78.1098 69.8186 78.1098 67.4914C78.1098 66.5273 77.3281 65.7456 76.364 65.7456C75.3999 65.7456 74.6182 66.5273 74.6182 67.4914C74.6182 69.8186 74.6182 72.1458 74.6182 74.4731C74.6182 75.4371 75.3999 76.2183 76.364 76.2183C77.3281 76.2183 78.1098 75.4371 78.1098 74.4731Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.3842 74.4731C53.3842 72.1458 53.3842 69.8186 53.3842 67.4914C53.3842 66.5273 52.6024 65.7456 51.6389 65.7456C50.6743 65.7456 49.8931 66.5273 49.8931 67.4914C49.8931 69.8186 49.8931 72.1458 49.8931 74.4731C49.8931 75.4371 50.6743 76.2183 51.6389 76.2183C52.6024 76.2183 53.3842 75.4371 53.3842 74.4731Z"
        fill="#3C3C3B"
      />
      <path
        d="M71.9279 57.0373C71.9279 54.7101 71.9279 52.3829 71.9279 50.0557C71.9279 49.0916 71.1462 48.3104 70.1821 48.3104C69.218 48.3104 68.4363 49.0916 68.4363 50.0557C68.4363 52.3829 68.4363 54.7101 68.4363 57.0373C68.4363 58.0014 69.218 58.7826 70.1821 58.7826C71.1462 58.7826 71.9279 58.0014 71.9279 57.0373Z"
        fill="#3C3C3B"
      />
      <path
        d="M74.6182 53.527C74.6182 55.8548 74.6182 58.182 74.6182 60.5092C74.6182 61.4733 75.3999 62.2544 76.364 62.2544C77.3281 62.2544 78.1098 61.4733 78.1098 60.5092C78.1098 58.182 78.1098 55.8548 78.1098 53.527C78.1098 52.5629 77.3281 51.7817 76.364 51.7817C75.3999 51.7817 74.6182 52.5635 74.6182 53.527Z"
        fill="#3C3C3B"
      />
      <path
        d="M68.4368 71.0012C68.4368 73.3284 68.4368 75.6557 68.4368 77.9834C68.4368 78.9475 69.2185 79.7287 70.1826 79.7287C71.1467 79.7287 71.9284 78.9469 71.9284 77.9834C71.9284 75.6557 71.9284 73.3284 71.9284 71.0012C71.9284 70.0372 71.1467 69.256 70.1826 69.256C69.2185 69.256 68.4368 70.0372 68.4368 71.0012Z"
        fill="#3C3C3B"
      />
      <path
        d="M65.7468 74.4731C65.7468 72.1458 65.7468 69.8186 65.7468 67.4914C65.7468 66.5273 64.965 65.7456 64.001 65.7456C63.0369 65.7456 62.2551 66.5273 62.2551 67.4914C62.2551 69.8186 62.2551 72.1458 62.2551 74.4731C62.2551 75.4371 63.0369 76.2183 64.001 76.2183C64.965 76.2183 65.7468 75.4371 65.7468 74.4731Z"
        fill="#3C3C3B"
      />
      <path
        d="M65.7468 60.5092C65.7468 58.182 65.7468 55.8548 65.7468 53.527C65.7468 52.5629 64.965 51.7817 64.001 51.7817C63.0369 51.7817 62.2551 52.5629 62.2551 53.527C62.2551 55.8548 62.2551 58.182 62.2551 60.5092C62.2551 61.4733 63.0369 62.2544 64.001 62.2544C64.965 62.2544 65.7468 61.4733 65.7468 60.5092Z"
        fill="#3C3C3B"
      />
      <path
        d="M59.5654 77.9829C59.5654 75.6551 59.5654 73.3279 59.5654 71.0007C59.5654 70.0366 58.7836 69.2554 57.8196 69.2554C56.8555 69.2554 56.0737 70.0366 56.0737 71.0007C56.0737 73.3279 56.0737 75.6551 56.0737 77.9829C56.0737 78.9469 56.8555 79.7281 57.8196 79.7281C58.7836 79.7281 59.5654 78.9469 59.5654 77.9829Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.3842 60.5092C53.3842 58.182 53.3842 55.8548 53.3842 53.527C53.3842 52.5629 52.6024 51.7817 51.6389 51.7817C50.6743 51.7817 49.8931 52.5629 49.8931 53.527C49.8931 55.8548 49.8931 58.182 49.8931 60.5092C49.8931 61.4733 50.6743 62.2544 51.6389 62.2544C52.6024 62.2544 53.3842 61.4733 53.3842 60.5092Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.4543 62.276C79.1276 62.276 79.0898 65.7152 81.4159 65.7671C83.7425 65.8185 83.7815 62.2766 81.4543 62.276Z"
        fill="#3C3C3B"
      />
      <path
        d="M57.8197 62.2737C55.4931 62.2737 55.4547 65.7129 57.7813 65.7648C60.108 65.8156 60.1469 62.2737 57.8197 62.2737Z"
        fill="#3C3C3B"
      />
      <path
        d="M70.1828 62.2737C67.8561 62.2737 67.8177 65.7129 70.1444 65.7648C72.4705 65.8156 72.51 62.2737 70.1828 62.2737Z"
        fill="#3C3C3B"
      />
      <path
        d="M64.0009 44.8002C61.6742 44.8002 61.6358 48.2388 63.9625 48.2907C66.2891 48.3421 66.3281 44.8002 64.0009 44.8002Z"
        fill="#3C3C3B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_23183"
          x1="64.0012"
          y1="109.077"
          x2="64.0012"
          y2="127.441"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_23183"
          x1="16.5597"
          y1="64.0001"
          x2="0.308902"
          y2="64.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_23183"
          x1="111.443"
          y1="64.0001"
          x2="127.693"
          y2="64.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
